import React, { Component } from 'react';
import {withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
class Personal extends Component{
    constructor(props){
        super(props)      
        this.validator = new SimpleReactValidator();
    }
    
    submitForm =(event)=> {
       
        event.preventDefault(); 
        if (this.validator.allValid()) {
            this.props.history.push(`/eligibility/${this.props.match.params.contary}/step2`);
           
       } else {
         this.validator.showMessages();
         this.forceUpdate();
       }
       
    }
    render(){
        return(
            <div>
                    <div className="progressbar-data pb-3 pt-4">
                        <div className="progressbar-container">
                            <ul className="progressbar">
                                <li className="active">
                                    <div className="pg-text">Personal</div>
                                    <div className="pg-text">Details</div>
                                </li>
                                <li>
                                    <div className="pg-text">Education</div>
                                    <div className="pg-text">Details</div>
                                </li>
                                <li>
                                    <div className="pg-text">Documents upload</div>
                                    <div className="pg-text">&amp; Declaration</div>
                                </li>
                                <li>
                                    <div className="pg-text">Fees &amp;</div>
                                    <div className="pg-text">Charges</div>
                                </li>
                            </ul>
                        </div>    
                    </div>
                    <div className="form-container mb-4">
                        <h4 className="heading4 text-color2 mb-3 pl-3">Personal Details</h4>
                        <div className="form-wrap mc-border px-4">                
                            <div className="pb-5 bb-1 px-lg-5">
                                <form action="" method="post">
                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="pfirtsName" className="form-label1">Title</label>
                                            <select className="form-control form-input1" name="name_prefix" value={this.props.name_prefix} onChange={(event)=>this.props.onSetInput(event)}>
                                                <option value="Mr.">Mr</option>
                                                <option value="Mrs.">Mrs</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="gender" className="form-label1">Gender</label>
                                            <select className="form-control form-input1" name="gender" value={this.props.person.gender} onChange={(event)=>this.props.onSetInput(event)}>
                                                <option value="m">Male</option>
                                                <option value="f">Female</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="first_name" className="form-label1">First Name</label>
                                            <input id="first_name" className="form-control form-input1" type="text" name="first_name" placeholder="First Name" value={this.props.person.first_name}  onChange={(event)=>this.props.onSetInput(event)}/>
                                            {this.validator.message('First Name', this.props.person.first_name, 'required|alpha_space', { className: 'text-danger' })}
 
                                        </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="last_name" className="form-label1">Last Name</label>
                                            <input id="last_name" className="form-control form-input1" type="text" name="last_name" placeholder="Last Name" value={this.props.person.last_name} onChange={(event)=>this.props.onSetInput(event)} />
                                            {this.validator.message('Last Name', this.props.person.last_name, 'required|alpha_space' ,{ className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>

                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="passport_name" className="form-label1">Name as on Passport</label>
                                            <input id="passport_name" className="form-control form-input1" type="text" name="passport_name" placeholder="Name as on Passport" value={this.props.person.passport_name} onChange={(event)=>this.props.onSetInput(event)} />
                                         </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="dob" className="form-label1">Date of Birth</label>
                                            <input id="dob" className="form-control form-input1" type="date" name="dob" placeholder="Date of Birth" value={this.props.person.dob} onChange={(event)=>this.props.onSetInput(event)}/>
                                            {this.validator.message('Date of Birth', this.props.person.dob, 'required' , { className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">                                                          
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label htmlFor="address" className="form-label1">Correspondence Address</label>
                                            <textarea name="address" id="address" rows="5" className="form-control form-input1" value={this.props.person.address} onChange={(event)=>this.props.onSetInput(event)}></textarea>
                                            {this.validator.message('Correspondence Address', this.props.person.address, 'required' , { className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>
                                </form>
                            </div>
                            <div className="pt-5  px-lg-5">
                            <form action="" method="post">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label htmlFor="permanent_address" className="form-label1">Students Permanent Address</label>
                                            <textarea name="permanent_address" id="permanent_address" rows="5" className="form-control form-input1" value={this.props.person.permanent_address} onChange={(event)=>this.props.onSetInput(event)}></textarea>
                                            {this.validator.message('Permanent Address', this.props.person.permanent_address, 'required' , { className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>
                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="mobile_number" className="form-label1">Mobile Number</label>
                                            <input id="mobile_number" className="form-control form-input1" type="text" name="mobile_number" placeholder="0000"   value={this.props.person.mobile_number} onChange={(event)=>this.props.onSetInput(event)}/>
                                            {this.validator.message('Mobile Number', this.props.person.mobile_number, 'required|phone' , { className: 'text-danger' })}
                                        </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="email" className="form-label1">Email</label>
                                            <input id="email" className="form-control form-input1" type="text" name="email" placeholder="Email" value={this.props.person.email} onChange={(event)=>this.props.onSetInput(event)} />
                                            {this.validator.message('Email', this.props.person.email, 'required|email' , { className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="home_number" className="form-label1">Home Number</label>
                                            <input id="home_number" className="form-control form-input1" type="text" name="home_number" placeholder="0000" value={this.props.person.home_number} onChange={(event)=>this.props.onSetInput(event)} />

                                        </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="guardian_mobile_number" className="form-label1">Father's Mobile</label>
                                            <input id="guardian_mobile_number" className="form-control form-input1" type="text" name="guardian_mobile_number" placeholder="0000" value={this.props.person.guardian_mobile_number} onChange={(event)=>this.props.onSetInput(event)} />
                                         </div>
                                    </div>
                                </div>
                                <div className="f-row">
                                    <div className="fr-left">
                                        <div className="form-group">
                                            <label htmlFor="country" className="form-label1">Country of birth</label>
                                            <select className="form-control form-input1" name="country" id="country" value={this.props.person.country} onChange={(event)=>this.props.onSetInput(event)}>
                                                <option>Pakistan</option>
                                                <option>Others</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="fr-right">
                                        <div className="form-group">
                                            <label htmlFor="nationality" className="form-label1">Nationality</label>
                                            <input id="nationality" className="form-control form-input1" type="text" name="nationality" placeholder="Nationality" value={this.props.person.nationality} onChange={(event)=>this.props.onSetInput(event)} /> 
                                            {this.validator.message('Nationality', this.props.person.nationality, 'required',  { className: 'text-danger' })}
                                        </div>
                                    </div>
                                </div>                                                         
                                <div className="row justify-content-center">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="passport_number" className="form-label1">Passport Number</label>
                                            <input id="passport_number" className="form-control form-input1" type="text" name="passport_number" placeholder="Passport Number" value={this.props.person.passport_number} onChange={(event)=>this.props.onSetInput(event)} />
                                         </div>
                                    </div> 
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                    <div className="form-group text-right">
                            <button type="button"   className="btn btn-apply" onClick={this.submitForm}>Continue</button>
                    </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        person: state.person
    };
};
const mapDispatchToProps = dispatch => {   
    return {
        onSetPerson: (person) => dispatch({type: 'SET_PERSON', person: person}),
        onSetInput:  (event)=> dispatch({type : 'SET_INPUT', event: event})
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Personal));